import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '../../aura';
import { FormContextData, useFormContext } from '../../state';
import { useValidation } from './helpers/use-validation';
import { useFormErrors } from './helpers/use-form-errors';

const MAX_LENGTH = 100;

export function Street(): JSX.Element {
  const { t } = useTranslation('input', { keyPrefix: 'street' });
  const {
    data: { address },
    setData,
  } = useFormContext();
  const { props: formErrorsProps, clear } = useFormErrors('address');

  const hasValue = useCallback(
    (data: FormContextData) => (data.address.street ? null : 'Street is empty'),
    [],
  );

  const validate = useCallback((data: FormContextData) => {
    if (!data.address.street) {
      return 'Street is empty';
    }
    if (data.address.street.length > MAX_LENGTH) {
      return 'Address.Street is too long';
    }
    return null;
  }, []);

  const extraInputProps = useValidation(t, hasValue, validate);

  const onValueChange = useCallback(
    (value: string) => {
      clear();
      setData(current => ({
        ...current,
        address: { ...current.address, street: value },
      }));
    },
    [setData, clear],
  );

  return (
    <Input
      id="street"
      type="text"
      label={t('label')}
      value={address.street}
      onValueChange={onValueChange}
      autoComplete="street-address"
      maxLength={MAX_LENGTH}
      {...extraInputProps}
      {...formErrorsProps}
    />
  );
}
